import { render, staticRenderFns } from "./SelectPharmacyTable.vue?vue&type=template&id=523e86b5&"
import script from "./SelectPharmacyTable.vue?vue&type=script&lang=js&"
export * from "./SelectPharmacyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports